import { gql } from '@apollo/client';

export const DELETE_COMPANY = gql`
    mutation deleteCompanyWithVerifyCode($companyDetails: DeleteCompany!) {
        system {
            company {
                delete(input: $companyDetails)
            }
        }
    }
`;
